export default __webpack_public_path__ + "static/media/steraks_gage.7e916d1d.png";